// SmartEdge program catalog. Consumed by ProgramsSection and ProgramDetail.

export const PROGRAMS = [
  {
    slug: "wellness-plan",
    icon: "ShieldPlus",
    title: "Preventative Wellness Plan",
    tagline: "IRS Section 125 compliant wellness that pays for itself.",
    body:
      "AI-powered employee wellness programs that reduce claims and unlock payroll tax savings through IRS Section 125 compliance.",
    detail: {
      lede:
        "A next-generation preventative wellness plan built on IRS Section 125 rules. Employees get meaningful benefits. Your payroll tax bill goes down. Nothing about your existing insurance changes.",
      highlights: [
        "Fully compliant under IRS Section 125 and HIPAA",
        "Reduces employer FICA + Medicare payroll taxes",
        "Improves employee take-home pay",
        "Layers on top of existing insurance — no disruption",
        "AI-driven guidance improves participation & health outcomes",
      ],
      how: [
        "We audit your payroll & benefits structure",
        "We design the plan for your workforce",
        "Our team handles implementation and provider setup",
        "Ongoing compliance monitoring and reporting",
      ],
    },
  },
  {
    slug: "tariff-refund",
    icon: "CircleDollarSign",
    title: "Tariff Refund Program",
    tagline: "Recover overpaid tariffs owed back to your business.",
    body:
      "Recover overpaid tariffs ruled unconstitutional. We navigate the claims process and secure refunds owed to your business.",
    detail: {
      lede:
        "Companies that imported goods under tariff regimes later ruled unconstitutional are owed refunds. SmartEdge handles the entire claim process end-to-end.",
      highlights: [
        "No upfront fees — we are paid from recovered funds",
        "Full documentation and filing handled by our team",
        "Works across a wide range of import categories",
        "Fast turnaround once eligibility is confirmed",
      ],
      how: [
        "Eligibility review of past import activity",
        "Documentation collection and validation",
        "Claim preparation and filing",
        "Refund tracking and disbursement",
      ],
    },
  },
  {
    slug: "rd-tax-credits",
    icon: "Lightbulb",
    title: "R&D Tax Credits",
    tagline: "Turn engineering and process work into federal tax credits.",
    body:
      "Maximize federal tax credits for qualifying research and development activities — software, products, processes, and innovations.",
    detail: {
      lede:
        "R&D credits are one of the most under-claimed incentives in the U.S. tax code. If your team builds software, iterates on products, or improves processes, you likely qualify.",
      highlights: [
        "Federal + many state R&D credits available",
        "Applies to software, engineering, manufacturing, formulation",
        "Can be applied against payroll taxes for eligible companies",
        "Full IRS-ready documentation package included",
      ],
      how: [
        "Qualification screen (30-minute call)",
        "Activity + expenditure mapping",
        "Credit calculation and substantiation",
        "Filing support and audit defense readiness",
      ],
    },
  },
  {
    slug: "power-plan",
    icon: "Zap",
    title: "SmartEdge Power Plan",
    tagline: "Turn your property into a revenue asset.",
    body:
      "Turn your property into a revenue asset with Tesla Supercharger installations. Strong cash flow, tax advantages, minimal effort.",
    detail: {
      lede:
        "The SmartEdge Power Plan converts underused property into cash-flowing infrastructure. Tesla Supercharger installations bring foot traffic, lease income, and depreciation benefits with minimal operational overhead.",
      highlights: [
        "Predictable long-term revenue stream",
        "Depreciation & tax advantages on installed assets",
        "Drives customer foot traffic to your business",
        "Handled end-to-end — site survey, install, activation",
      ],
      how: [
        "Property assessment and feasibility review",
        "Utility & permitting coordination",
        "Installation and Tesla partner onboarding",
        "Revenue reporting and optimization",
      ],
    },
  },
];

export const findProgram = (slug) =>
  PROGRAMS.find((p) => p.slug === slug) || null;
